/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../color/color-hsl';
import '../grid/grid';
import '../typography/typography';
import css from './form-checkbox.css';
import FormCheckLabel from './form-check-label';

const FormCheckbox = ({ labelText, isIndeterminate, ...otherProps }) => (
  <div
    className={classnames(css['ds-form-checkbox'], {
      [css['ds-form-checkbox--indeterminate']]:
        isIndeterminate && !otherProps.defaultChecked,
    })}
  >
    <input type='checkbox' {...otherProps} />
    <div className={css['ds-form-checkbox__box']} />
    <FormCheckLabel isDisabled={otherProps.disabled} htmlFor={otherProps.id}>
      {labelText}
    </FormCheckLabel>
  </div>
);

FormCheckbox.defaultProps = {
  isIndeterminate: false,
};

FormCheckbox.propTypes = {
  isIndeterminate: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
};

export default FormCheckbox;
